import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Observable } from "rxjs/Observable";

import { StudentDetails } from "../examinees/examinee.model";
import { ReviewData } from "../shared/models/review-data";

@Injectable()
export class CommonService {
  private studentDetails = new BehaviorSubject<StudentDetails>(null);
  public confirmationPageDetails: ReviewData = {};

  public studentDetailsMessage: any;

  public dynamicContent: any;
  constructor(private _http: HttpClient, private httpService: Http) {}

  sendStudentDetails(studentDetails: StudentDetails) {
    this.studentDetailsMessage = studentDetails;
  }

  getStudentDetails() {
    return this.studentDetailsMessage;
  }

  /**
   * @description Used to get the value from the database of a specific dynaminic content row.
   * @param text
   */
  getDynamicContent(text: string) {
    return this._http.get(`/api/dynamicContent/DynamicContent`, {
      params: { type: text },
      responseType: "json"
    });
  }

  getDynContent(body: string) {
    return this.getDynamicContent(body).map(data => {
      this.dynamicContent = data[0].DYNAMIC_CONTENT_VAL;
      return this.dynamicContent;
    });
  }

  setComfirmationPageData(data: ReviewData) {
    this.confirmationPageDetails = data;
  }

  getComfirmationPageData() {
    return this.confirmationPageDetails;
  }

  getFinishedRecordCount(personId: string): Observable<Object> {
    return this.httpService
      .get(`/api/getFinishedRecordDetails/${personId}`)
      .map(res => {
        const data = (<any>res).json();
        return data;
      });
  }
  getReviewDetailCount(requestId: string): Observable<Object> {
    return this.httpService
      .get(`/api/getReviewDetailCount/${requestId}`)
      .map(res => {
        const data = (<any>res).json();
        return data;
      });
  }

  getFinishedRecCount(requestId: string): Observable<Object> {
    return this.httpService
      .get(`/api/getFinishedRecDetails/${requestId}`)
      .map(res => {
        const data = (<any>res).json();
        return data;
      });
  }

  updateRequestForReconsider(payload: any) {
    return this._http.put(
      `/api/DocumentType/updateRequestForReconsider`,
      payload,
      { observe: "response" }
    );
  }

  getExternalPersonId(actId: string): Observable<Object> {
    return this._http.get(`/api/ActIdService/getExternalPersonId`, {
      params: { actId: actId },
      responseType: "json",
      observe: "response"
    });
  }

  getActIdByExternalId(externalPersonId: string): Observable<Object> {
    return this._http.get(`/api/ActIdService/getActId`, {
      params: { externalPersonId: externalPersonId },
      responseType: "json",
      observe: "response"
    });
  }
}



// WEBPACK FOOTER //
// ./client/views/services/common.service.ts